import {
  enumKeySource,
  kTabKey,
  kReturnKey,
  kDeleteKey,
  kBackspaceKey,
  kEscKey,
  kLeftArrow,
  kUpArrow,
  kDownArrow,
  kF1Key,
  kF8Key,
  kF9Key,
  kF12Key,
  kPeriodKey,
  kPeriodKeyPad,
  kPeriodCharCode,
  kRightArrow
} from "../constants";

export function HandleBrowserKeyEvent(event, kInfo) {
  kInfo.keyCode = event.keyCode;
  kInfo.charCode = event.charCode;
  kInfo.ctrlKey = event.ctrlKey;
  kInfo.shiftKey = event.shiftKey;
  kInfo.altKey = event.altKey;
  if (kInfo.source == enumKeySource.keyPress) {
    switch (kInfo.keyCode) {
      case kTabKey:
      case kReturnKey:
      case kDeleteKey:
      case kBackspaceKey:
        break;
      default:
        kInfo.ignoreEvent = false;
        break;
    }
    if (kInfo.charCode != 0) kInfo.keyCode = 0;

    //console.log("KeySource - keypress: KeyCode:", kInfo.keyCode, " CharCode:", kInfo.charCode, " Ignore:", kInfo.ignoreEvent);
  } else {
    switch (kInfo.keyCode) {
      case kTabKey:
      case kReturnKey:
      case kDeleteKey:
      case kBackspaceKey:
        kInfo.charCode = kInfo.keyCode;
        kInfo.ignoreEvent = false;
        break;
      case kEscKey:
      case kLeftArrow:
      case kUpArrow:
      case kRightArrow:
      case kDownArrow:
        //case kDeleteKey:
        kInfo.ignoreEvent = false;
        break;
      case kF1Key:
      case kF8Key:
      case kF9Key:
      case kF12Key:
        kInfo.funcKey = true;
        kInfo.ignoreEvent = false;
        break;
      case kPeriodKey:
      case kPeriodKeyPad:
        if (!kInfo.shiftKey) {
          kInfo.charCode = kPeriodCharCode; //kPeriodKey;
          kInfo.ignoreEvent = false;
        }
        break;
      /*
			case kDelKeyPad:	// Other Del (on keypad)
				kInfo.charCode = kDeleteKey;
				kInfo.ignoreEvent = false;
				break;
		  */
    }

    if (kInfo.ctrlKey && kInfo.ignoreEvent) {
      //console.log("KeySource1 - keyDown: KeyCode:", kInfo.keyCode, " CharCode:", kInfo.charCode, " Ignore:", kInfo.ignoreEvent);

      switch (kInfo.keyCode) {
        case 65: // 'ctrl-a' - select all
        case 66: // 'ctrl-b' - bold
        case 67: // 'ctrl-c' - copy
        case 73: // 'ctrl-i' - italic
        //	case 76: // 'ctrl-l' - layout editor
        case 86: // 'ctrl-v' - paste
        case 88: // 'ctrl-x' - cut
        case 89: // 'ctrl-y' - redo
        case 90: // 'ctrl-z' - undo
        case 83: // 'ctrl-s' - save
          kInfo.ignoreEvent = false;
          kInfo.charCode = kInfo.keyCode + 32;
          break;
      }
    }
  }
}
